// Regex helper: https://regexr.com/

exports.alphanumeric = {
  r: RegExp(/[a-z0-9)]/i),
};

exports.dashes = {
  r: RegExp(/-+/g),
};

exports.email = {
  r: RegExp(/^[^\s@]+@[^\s@]+\.[^\s@]+$/),
  warning: "must be properly formatted",
};

// https://emailregex.com/

exports.endsWithTag = {
  r: RegExp(/<$/),
};

exports.extraSpaces = {
  r: RegExp(/  +/g),
};

exports.hashtag = {
  r: RegExp(/#\w+/g), // Alternative: to capture everything till whitespace: /#\S+/g
};

exports.invalidFirstChar = {
  r: RegExp(/^(~|<|>|\(|\)|\+|-|\*)/g),
};

exports.invalidLastChar = {
  r: RegExp(/(~|<|>|\(|\)|\+|-|\*)$/g),
};

exports.letter = {
  r: RegExp(/^[a-z]/i),
};

exports.mention = {
  r: RegExp(/@\w+/g), // Alternative: to capture everything till whitespace: /@\S+/g
  r2: (username) => RegExp(`@${username}\\b`, "g"),
};

exports.refChar = {
  r: RegExp(/#|@/g),
};

exports.refWord = {
  r: RegExp(/#\w+|@\w+/g),
};

exports.specialChar = {
  r: RegExp(/^\w+$/),
  warning: "can only contain letters, numbers, and '_'",
};

exports.whitespace = {
  r: RegExp(/^\S+$/),
  warning: "can't include spaces/whitespaces",
};
